import { AccountBadgeOutlineIcon } from './AccountBadgeOutlineIcon';

/**
 * author: Andrej Sharapov
 * id 897CF76D-01B6-47B8-B917-542077D94343
 * name account-badge-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-badge-outline.svg
 * tags
 * - Account / User 
 */
export const AccountOnlineOutlineIcon = AccountBadgeOutlineIcon;
export default AccountOnlineOutlineIcon